import { Box, Container } from "@mui/material";

import "./ModuleContainer.css";

function ModuleContainer({ component: Component, module, path }) {
  return (
    <Box component="section" className="module-background">
      <Container maxWidth="lg" className="module-container">
        <Component module={module} path={path} />
      </Container>
    </Box>
  );
}

export default ModuleContainer;
